import { useCallback, useState } from "react";
import { TOperadoraCartao } from "../../../../../types/api/financeiro/operadoras-cartao";
import DialogCriacaoEditOperadorasCartao from "./DialogCriacaoEditOperadorasCartao";
import SessaoConfiguracao, { ConfiguracaoColunas } from "../../../../../components/BasicComponents/DisplayDados/SessaoConfiguracao";

export default function OperadorasCartao() {

    const [openModal, setOpenModal] = useState<TOpenModalOperadoraCartao | null>(null)

    //funções manipuladoras
    const handleModalAction = useCallback((action: "open" | "close", id?: true | number, value?: TOperadoraCartao | null) => {
        if (action === "close") setOpenModal(null)
        if (action === "open" && id && value) setOpenModal({ open: id, defaultValue: value })
        if (action === "open" && id && !value) setOpenModal({ open: id, defaultValue: null })
    }, [])
    //

    return (
        <>
            <SessaoConfiguracao<TOperadoraCartao>
                titulo="Operadoras de cartão"
                endpoints={{
                    listar: "financeiro/configuracoes/pesquisar-operadoras-cartao",
                    deletar: "financeiro/configuracoes/excluir-operadora-cartao",
                }}
                colunas={colunas}
                queryKey="pesquisar-operadoras-cartao"
                onEditar={(opCartao) => {
                    handleModalAction("open", opCartao.id, opCartao)
                }}
                onAdicionar={() => {
                    handleModalAction("open", true, null)
                }}
                mensagemSucessoDeletar="Operadora de cartão deletada com sucesso!"
                mensagemErroDeletar="Erro ao deletar operadora de cartão!"
                mensagemSemDados="Nenhuma operadora de cartão encontrada."
            />

            {
                Boolean(openModal?.open) &&
                <DialogCriacaoEditOperadorasCartao
                    defaultValue={openModal?.defaultValue ? openModal : null}
                    open={Boolean(openModal?.open)}
                    handleClose={() => handleModalAction("close")}
                />
            }

        </>
    )
}

export type TOpenModalOperadoraCartao = {
    open: number | boolean | null,
    defaultValue: TOperadoraCartao | null,
} | null

const colunas: ConfiguracaoColunas<TOperadoraCartao>[] = [
    {
        campo: "id",
        titulo: "Código",
    },
    {
        campo: "nome",
        titulo: "nome",
    },
];
